// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VoEHn {
    padding: 16px;
}

.J13bU {
    margin-bottom: 20px;
}

.N_bWi {
    margin-bottom: 30px;
}

.to_OK {
    display: block;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    color: #555;
}

.RP9nq {
    width: 100%;
    height: 50px;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 0 12px;
    font-size: 16px;
    color: #333;
    background: white;
}

.RP9nq::placeholder {
    color: #999;
}

.RgseM {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: flex-start;
}

._I9Ec {
    width: 40px;
    height: 40px;
    border-radius: 20px;
    margin: 5px;
    overflow: hidden;
    cursor: pointer;
    padding: 0;
}

.d_iDX {
    width: 100%;
    height: 100%;
    border-radius: 20px;
}

.jWkSr {
    border: 2px solid #2196F3;
}

.G5f3o {
    border: 1px solid #ccc;
}

@media (min-width: 768px) {
    ._I9Ec {
        width: 50px;
        height: 50px;
        border-radius: 25px;
    }

    .d_iDX {
        border-radius: 25px;
    }

    .RP9nq {
        font-size: 18px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/player/PlayerSettingsModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".container {\n    padding: 16px;\n}\n\n.section {\n    margin-bottom: 20px;\n}\n\n.lastSection {\n    margin-bottom: 30px;\n}\n\n.sectionTitle {\n    display: block;\n    font-size: 16px;\n    font-weight: bold;\n    margin-bottom: 10px;\n    color: #555;\n}\n\n.nameInput {\n    width: 100%;\n    height: 50px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 0 12px;\n    font-size: 16px;\n    color: #333;\n    background: white;\n}\n\n.nameInput::placeholder {\n    color: #999;\n}\n\n.colorGrid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    justify-content: flex-start;\n}\n\n.colorOption {\n    width: 40px;\n    height: 40px;\n    border-radius: 20px;\n    margin: 5px;\n    overflow: hidden;\n    cursor: pointer;\n    padding: 0;\n}\n\n.gradientFill {\n    width: 100%;\n    height: 100%;\n    border-radius: 20px;\n}\n\n.activeColorOption {\n    border: 2px solid #2196F3;\n}\n\n.inactiveColorOption {\n    border: 1px solid #ccc;\n}\n\n@media (min-width: 768px) {\n    .colorOption {\n        width: 50px;\n        height: 50px;\n        border-radius: 25px;\n    }\n\n    .gradientFill {\n        border-radius: 25px;\n    }\n\n    .nameInput {\n        font-size: 18px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `VoEHn`,
	"section": `J13bU`,
	"lastSection": `N_bWi`,
	"sectionTitle": `to_OK`,
	"nameInput": `RP9nq`,
	"colorGrid": `RgseM`,
	"colorOption": `_I9Ec`,
	"gradientFill": `d_iDX`,
	"activeColorOption": `jWkSr`,
	"inactiveColorOption": `G5f3o`
};
export default ___CSS_LOADER_EXPORT___;
